module.exports = __webpack_public_path__ + "static/media/html5_logo_2.f2282f94.png";